import { useForm, useFormState, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useStoreFilesForRetainerReqest from './useStoreFilesForRetainerReqest';
import { useEffect } from 'react';
import { getSingleImpressionTypeSchema } from '../../../components/DifferentRetainer/YupValidation';
import { useLang } from '../../../util/lang';
import { CaseImpressionFileType } from '../../DiffRetainer/modal/type';

/**
 * @typedef {Object} IMPRESSION_TYPE
 * @property {string} upper
 * @property {string} lower
 * @property {string} upperAndLower
 */
export const IMPRESSION_TYPE = {
    UPPER: 'upper',
    LOWER: 'lower',
    UPPER_AND_LOWER: 'upperAndLower',
};

export const FILES_ERR_MSG = '@DiffRetainer.errorMessage.uploadFile';

const useRetainerRequestForm = ({ schema, isTab }) => {
    const get = useLang();
    const { isFileReady } = useStoreFilesForRetainerReqest();
    const targetSchema = schema ? schema : getSingleImpressionTypeSchema(get('@global.const.required'), isTab);
    const methods = useForm({
        resolver: yupResolver(targetSchema),
    });

    const {
        formState: { errors },
        control,
        setError,
        clearErrors,
        watch,
    } = methods;

    const formValues = useWatch({ control });
    const { dirtyFields } = useFormState({
        control,
    });
    const impressionOption = watch('impressionOption');

    useEffect(() => {
        if (isTab) {
            clearErrors('impressionOption');
            return;
        }
        const isFileType = impressionOption === CaseImpressionFileType.FILE;
        if (isFileType && !isFileReady) {
            setError('impressionOption', {
                type: 'manual',
                message: get(FILES_ERR_MSG),
            });
        } else {
            clearErrors('impressionOption');
        }
    }, [impressionOption, isFileReady, setError, clearErrors, isTab]);

    return {
        errors,
        formValues,
        dirtyFields,
        methods,
    };
};

export default useRetainerRequestForm;
